import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useSWR from "swr";
import { Typography } from "@material-ui/core";
import LinearLoader from "components/LinearLoader";
import { fetcher, isNotFound } from "utils/apiRequestWithErrorCode";
import RuleCard from "./RuleCard";
import AccountsCards from "./AccountsCards";
import AccountsTable from "./AccountsTable";
import Message from "./Message";
import { StatsContainer } from "./styled";

import { MailboxRuleStats, Rule } from "@dashboard-v3/api";

const swrOptions = { revalidateOnFocus: false, shouldRetryOnError: false };

export default function AccountStats() {
  const { t } = useTranslation("stats");
  const { id: ruleId } = useParams();

  const { data: rule, error: ruleError } = useSWR<Rule>(
    `/rules/${ruleId}`,
    fetcher,
    swrOptions
  );

  const { data: stats, error: statsError } = useSWR<MailboxRuleStats>(
    rule ? `/rules/${ruleId}/stats` : null,
    fetcher,
    swrOptions
  );

  const ruleNotFound = isNotFound(ruleError);
  const noTask = Boolean(rule) && !rule.enabled && isNotFound(statsError);
  const loading =
    (!rule && !ruleError) || (Boolean(rule) && !stats && !statsError);

  if (ruleNotFound) {
    return (
      <Message
        title={t("accounts.ruleNotFound.title")}
        description={t("accounts.ruleNotFound.description")}
      />
    );
  }

  if (noTask) {
    return (
      <Message
        title={t("accounts.noTask.title")}
        description={t("accounts.noTask.description")}
      />
    );
  }

  if (loading) return <LinearLoader />;

  return (
    <StatsContainer>
      <Typography variant="h6" style={{ fontSize: "26px" }}>
        {t("accounts.ruleCard.title")}
      </Typography>
      <RuleCard ruleId={ruleId} />
      <Typography variant="h6" style={{ fontSize: "26px" }}>
        {t("accounts.accountCards.title")}
      </Typography>
      <AccountsCards ruleId={ruleId} />
      <AccountsTable ruleId={ruleId} />
    </StatsContainer>
  );
}
